// extracted by mini-css-extract-plugin
export default {"contentWrapper":"Styles_contentWrapper__AXOBT","names":"Styles_names__cgR5-"};